var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as Yup from 'yup';
import { DEGREE_OPTIONS, POPULAR_COUNTRIES } from '../../constants/optionsData';
import { getGroupedIntakes, getWeatherIntakeStartMonthFromToday } from '../../helpers/intakes';
export var UNIVERSITY_FILTERS_KEY = 'university_count';
export var LOCATION_FILTERS_KEY = 'location';
export var CITY_FILTERS_KEY = 'city_count';
export var STATE_FILTERS_KEY = 'state_count';
export var DURATION_FILTERS_KEY = 'duration_count';
export var ADDITIONAL_FILTERS_KEY = 'additional_filters';
export var GENERAL_FILTERS_KEY = 'general_filters';
export var SHOW_ONLY_PREFERRED = 'show_on_preferred';
export var tutionFee = [
    { id: 1, label: 'Upto 20 Lakhs', value: '2000000' },
    { id: 2, label: 'Upto 40 Lakhs', value: '4000000' },
    { id: 3, label: 'Upto 60 Lakhs', value: '6000000' },
    { id: 4, label: 'Upto 80 Lakhs', value: '8000000' },
    { id: 5, label: 'No preference', value: '70000000' }
];
var startIntakeMonth = getWeatherIntakeStartMonthFromToday();
export var groupedIntakes = getGroupedIntakes({
    monthShort: true,
    monthCharLength: 3,
    startMonth: startIntakeMonth.month,
    startYear: startIntakeMonth.year
}).groupedIntakes;
export var extractedIntakes = groupedIntakes
    .reduce(function (acc, eachGroup) { return __spreadArray(__spreadArray([], __read(acc), false), __read(eachGroup.intakeGroups), false); }, [])
    .map(function (eachOption) { return ({
    label: eachOption.title.split('(')[1].split(')')[0],
    value: JSON.stringify(eachOption.months.map(function (eachMonth) { return eachMonth.value; }))
}); })
    .splice(0, 6);
export var cfSearchFilters = [
    {
        name: 'Country',
        key: 'COUNTRY',
        options: POPULAR_COUNTRIES,
        multiple: true
    },
    {
        name: 'Degree',
        key: 'DEGREE',
        options: DEGREE_OPTIONS,
        multiple: true
    },
    {
        name: 'Intake',
        required: true,
        key: 'INTAKE',
        options: extractedIntakes,
        multiple: true
    },
    {
        name: 'Tuition Fees',
        key: 'TUITION_FEE',
        options: tutionFee,
        multiple: true
    }
];
export var openOnlyAdditionalFilter = {
    title: 'FILTERS',
    key: GENERAL_FILTERS_KEY,
    showTitle: true,
    isSearchable: false,
    isClearable: false,
    showCount: false,
    options: [
        {
            key: GENERAL_FILTERS_KEY,
            id: 'OPEN',
            title: 'Show Open Only'
        }
    ]
};
export var showOnlyPreferredInstitute = {
    title: 'FILTERS',
    key: SHOW_ONLY_PREFERRED,
    showTitle: false,
    isSearchable: false,
    isClearable: false,
    options: [
        {
            key: SHOW_ONLY_PREFERRED,
            id: 'PREFERED',
            title: 'Show only High Offer Institutes'
        }
    ]
};
export var TOTAL_PER_PAGE = 30;
export var OTHER_FILTER_TITLE_MAP = {
    gmat_count: 'Without GMAT',
    gre_count: 'Without GRE',
    ielts_count: 'Without IELTS',
    toefl_count: 'TOEFL Accepted',
    pte_count: 'PTE Accepted',
    det_count: 'Duolingo Accepted',
    moi_accepted_count: 'MOI Accepted',
    no_app_fee_count: 'No Application Fee',
    spouse_visa_preferred_count: 'Spousal Visa Preferred',
    pgbwp_cases_count: 'PGWP Cases',
    fifteen_year_education_allowed_count: '15 Years of Education Allowed'
};
export var SORT_OPTIONS = [
    {
        id: 'RANKING',
        label: 'Ranking',
        order: 'ASC'
    },
    {
        id: 'POPULARITY',
        label: 'Popularity',
        order: 'DESC'
    },
    {
        id: 'TUITION_FEE_INR',
        label: 'Tuition Fee Increasing',
        order: 'ASC'
    },
    {
        id: 'TUITION_FEE_INR',
        label: 'Tuition Fee Decreasing',
        order: 'DESC'
    }
];
export var MIN_BOOKMARK_TITLE_LENGTH = 0;
export var MAX_BOOKMARK_TITLE_LENGTH = 255;
export var courseDetailsMapping = {
    ieltsScore: {
        label: 'IELTS',
        fieldType: 'textfield'
    },
    ieltsMinBand: {
        label: 'IELTS (Sub Min)',
        fieldType: 'textfield'
    },
    toeflScore: {
        label: 'TOEFL',
        fieldType: 'textfield'
    },
    toeflMinBand: {
        label: 'TOEFL (Sub Min)',
        fieldType: 'textfield'
    },
    partner: {
        label: 'Partner',
        fieldType: 'textfield'
    },
    twelfthScore100: {
        label: '12th Score',
        fieldType: 'textfield'
    },
    ugScore100: {
        label: 'UG Score',
        fieldType: 'textfield'
    },
    fifteenYearEducationAllowed: {
        label: '15 Yrs. of Education',
        fieldType: 'dropdown'
    },
    greRequired: {
        label: 'GRE Required',
        fieldType: 'dropdown'
    },
    gmatRequired: {
        label: 'GMAT Required',
        fieldType: 'dropdown'
    }
};
export var yesNoDropdownOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
];
export var courseCardFormSchema = Yup.object().shape({
    greRequired: Yup.object({
        label: Yup.string(),
        value: Yup.boolean()
    }).nullable(),
    gmatRequired: Yup.object({
        label: Yup.string(),
        value: Yup.boolean()
    }).nullable(),
    fifteenYearEducationAllowed: Yup.object({
        label: Yup.string(),
        value: Yup.boolean()
    }).nullable(),
    ieltsScore: Yup.number().min(0, 'Please enter between 0 to 9').max(9, 'Please enter between 0 to 9'),
    ieltsMinBand: Yup.number().min(0, 'Please enter between 0 to 9').max(9, 'Please enter between 0 to 9'),
    toeflScore: Yup.number().min(0, 'Please enter between 0 to 120').max(120, 'Please enter between 0 to 120'),
    toeflMinBand: Yup.number().min(0, 'Please enter between 0 to 120').max(120, 'Please enter between 0 to 120'),
    twelfthScore100: Yup.number().min(0, 'Please enter between 0 to 100').max(100, 'Please enter between 0 to 100'),
    ugScore100: Yup.number().min(0, 'Please enter between 0 to 100').max(100, 'Please enter between 0 to 100')
});
//# sourceMappingURL=constants.js.map